import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BaseService } from "app/core/base.service";
import { Observable } from "rxjs";
import { ModoLiquidacao } from "../models/modoLiquidacao.model";
import { ApiService } from "./api.services";

@Injectable()
export class ModoLiquidacaoService extends ApiService implements BaseService<ModoLiquidacao>{
    private strAction = 'api/ModoLiquidacao';

    constructor(
        httpClient: HttpClient,
        private route: Router) {
        super(httpClient, route);
    }

    deleteById(idModoLiqui: number) {
        return this.post(this.strAction + `/DeleteById?id=${idModoLiqui}`);
    }

    getAll(): Observable<ModoLiquidacao[]> {
        return this.get<ModoLiquidacao[]>(this.strAction + `/GetAll`);
    }


    getById(idModoLiqui: number): Observable<ModoLiquidacao> {
        return this.get(this.strAction + `/GetById/${idModoLiqui}`);
    }


}